import React, { useState, useEffect } from 'react';
import { Button, TextField, Grid, MenuItem, Select, InputLabel, FormControl, Snackbar, Alert } from '@mui/material';
import { getDatabase, ref, push, set } from 'firebase/database';
import Navbar from './Navbar';
import fc from '../firebaseConfig';
import { useNavigate } from 'react-router-dom'; // Import useNavigate

const db = getDatabase(fc);

const addProduct = async (product) => {
  const productsRef = ref(db, 'products');
  const newProductRef = push(productsRef);
  await set(newProductRef, product);
};

const AddProduct = () => {
  const [name, setName] = useState('');
  const [quantity, setQuantity] = useState('');
  const [type, setType] = useState('');
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [fieldErrors, setFieldErrors] = useState({});
  
  const navigate = useNavigate(); // Initialize useNavigate

  useEffect(() => {
    const loggedIn = localStorage.getItem('LOGGED_IN');
    if (!loggedIn) {
      navigate('/'); // Redirect to homepage if not logged in
    }
  }, [navigate]);

  const handleSave = async () => {
    setErrorMessage('');
    const errors = {};

    if (!name) errors.name = true;
    if (!quantity || isNaN(quantity)) errors.quantity = true;
    if (!type) errors.type = true;

    if (Object.keys(errors).length > 0) {
      setFieldErrors(errors);
      setErrorMessage('Wszystkie pola muszą być wypełnione.');
      return;
    }

    const newProduct = {
      name,
      quantity: parseFloat(quantity),
      type
    };

    await addProduct(newProduct);
    setOpenSnackbar(true);

    // Clear the form fields
    setName('');
    setQuantity('');
    setType('');
  };

  const handleSnackbarClose = () => {
    setOpenSnackbar(false);
  };

  const handleInputChange = (setter, field) => (event) => {
    setter(event.target.value);
    setFieldErrors((prevErrors) => ({ ...prevErrors, [field]: false }));
  };

  return (
    <div className="add-product">
      <Navbar />
      <div className="form-wrapper">
        <div className="container" style={{ width: '40rem', marginTop: '10rem' }}>
          <h1>Dodaj Produkt</h1>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField
                label="Nazwa produktu"
                variant="outlined"
                value={name}
                onChange={handleInputChange(setName, 'name')}
                fullWidth
                error={fieldErrors.name}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                label="Ilość"
                variant="outlined"
                value={quantity}
                onChange={handleInputChange(setQuantity, 'quantity')}
                fullWidth
                type="number"
                error={fieldErrors.quantity}
              />
            </Grid>
            <Grid item xs={12}>
              <FormControl fullWidth error={fieldErrors.type}>
                <InputLabel id="type-select-label">Typ Ilości</InputLabel>
                <Select
                  labelId="type-select-label"
                  value={type}
                  onChange={handleInputChange(setType, 'type')}
                  fullWidth
                >
                  <MenuItem value="ml">ml (mililitrów)</MenuItem>
                  <MenuItem value="l">l (litrów)</MenuItem>
                  <MenuItem value="g">g (gramów)</MenuItem>
                  <MenuItem value="kg">kg (kilogramów)</MenuItem>
                  <MenuItem value="szt">szt (sztuk)</MenuItem> {/* New option added */}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12}>
              <Button variant="contained" color="primary" onClick={handleSave}>
                Zapisz Produkt
              </Button>
            </Grid>
          </Grid>
          {errorMessage && (
            <div style={{ color: 'red', marginTop: '16px' }}>
              {errorMessage}
            </div>
          )}
        </div>
      </div>
      <Snackbar
        open={openSnackbar}
        autoHideDuration={2000}
        onClose={handleSnackbarClose}
      >
        <Alert onClose={handleSnackbarClose} severity="success" sx={{ width: '100%' }}>
          Produkt dodany pomyślnie!
        </Alert>
      </Snackbar>
    </div>
  );
};

export default AddProduct;
